import { useLayout } from '@/layout/LayoutProvider';
import { Props as InputProps, Input as OldInput } from '@storeblocks/input';
import { InputField, InputFieldProps } from '@storeblocks/input-molecules';
import { Ref, forwardRef } from 'react';

const getRebrandedInputIconButtonProps = (
  iconButtonProps: InputProps['iconButtonProps']
): InputFieldProps['iconButtonProps'] => {
  if (!iconButtonProps) {
    return {};
  }

  return {
    ...iconButtonProps,
    as: iconButtonProps.as === 'button' ? 'button' : undefined,
    variant: iconButtonProps.variant === 'outlined' ? 'secondary' : 'primary',
    size: 'small'
  };
};

const getRebrandedInputSize = ({
  fluid,
  large,
  medium
}: InputProps): InputFieldProps['size'] => {
  if (fluid) {
    return 'fluid';
  }
  if (large) {
    return 'large';
  }
  if (medium) {
    return 'medium';
  }
  return undefined;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps, ref: Ref<HTMLInputElement>) => {
    const { isRebrand } = useLayout();
    const { iconButtonProps, label, error } = props;

    // @ts-ignore: Incorrect error type alerts, being worked on by pretzel
    const rebrandedInputProps: InputFieldProps = {
      ...props,
      labelText: (label as string) || '',
      iconButtonProps: getRebrandedInputIconButtonProps(iconButtonProps),
      size: getRebrandedInputSize(props),
      ...(typeof error === 'string' && {
        alertMessage: error,
        alertMessageType: 'error'
      })
    };

    return isRebrand ? (
      <InputField {...rebrandedInputProps} ref={ref} />
    ) : (
      <OldInput {...props} ref={ref} />
    );
  }
);

export default Input;
